module.exports = __webpack_public_path__ + "img/text.9d6fea3f.png";